module.exports = __webpack_public_path__ + "static/img/entidad.e0aac67a.png";